export default (patientKey) => {
  return patientKey[0] === "-";
};
